export default function HintsMessage(locale = `ja`, perspective = 0, page = 'TRADE_RANKING') {
  const message = {
    ja: {
      0: {
        'TRADE_RANKING': [],
        'SIMILAR_CHART': [
          {
            element: `.riseFallBar`,
            hint: `基準日を起点とした予測日を指定してください。<br />
                    例えば、基準日が、4月1日（木）で１週間後の4月8日（木）を予測したい場合は、<br />
                    ５営業先となるため、【５】を指定していただく必要があります。`,
          },
          {
            element: `.forwardOption`,
            hint: `チャートの表示期間を比較対象期間である基準日までとする事ができます。<br />
                    表示期間を基準日までとする事により、類似チャートの比較が容易になります。`,
          },
        ],
      },
      1: {
        'TRADE_RANKING': [],
        'SIMILAR_CHART': [],
      },
    },
    en: {
      0: {
        'TRADE_RANKING': [],
        'SIMILAR_CHART': [
          {
            element: `.riseFallBar`,
            hint: `Please specify the forecast date starting from the base date.<br />
                      For example, if the base date is April 1 (Thursday) and you want to predict April 8 (Thursday),<br />
                      which is one week later, you need to specify "5" because it will be 5 business days.`,
          },
          {
            element: `.forwardOption`,
            hint: `The display period of the chart can be set to the base date<br />
                      which is the comparison target period.<br />
                      By setting the display period up to the base date,<br />
                      it becomes easy to compare similar charts.`,
          },
        ],
      },
      1: {
        'TRADE_RANKING': [],
        'SIMILAR_CHART': [],
      },
    },
  }
  //switch (page) {
  //  case 'TRADE_RANKING':
  //  case 'SIMILAR_CHART':
  //    break;
  //  default:
  //    return []
  //}
  if (message[locale] === undefined || message[locale][perspective] === undefined || message[locale][perspective][page] === undefined) {
    return []
  }
  return message[locale][perspective][page]
}